import type { EmployeeQualificationResponse } from "./EmployeeQualificationResponse";

export class EmployeeQualificationListItem {
  employeeQualificationId: number;
  employeeId: number;
  employeeName: string;
  qualificationId: number;
  qualificationCode: string;
  qualificationName: string;
  acquiredDate: string;
  expiresOn: string | null;
  certificationNumber: string;
  notes: string;
  isExpired: boolean;
  isExpiringSoon: boolean;
  daysUntilExpiry: number | null;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;

  constructor(response: EmployeeQualificationResponse) {
    this.employeeQualificationId = response.employeeQualificationId;
    this.employeeId = response.employeeId;
    this.employeeName = response.employeeName;
    this.qualificationId = response.qualificationId;
    this.qualificationCode = response.qualificationCode;
    this.qualificationName = response.qualificationName;
    this.acquiredDate = response.acquiredDate;
    this.expiresOn = response.expiresOn;
    this.certificationNumber = response.certificationNumber;
    this.notes = response.notes;
    this.isExpired = response.isExpired;
    this.isExpiringSoon = response.isExpiringSoon;
    this.daysUntilExpiry = response.daysUntilExpiration;
    this.createdDate = response.createdDate;
    this.createdBy = response.createdBy;
    this.modifiedDate = response.modifiedDate;
    this.modifiedBy = response.modifiedBy;
  }

  get expiryStatus(): 'expired' | 'expiring-soon' | 'valid' | 'no-expiry' {
    if (!this.expiresOn) return 'no-expiry';
    if (this.isExpired) return 'expired';
    if (this.isExpiringSoon) return 'expiring-soon';
    return 'valid';
  }

  get expirySeverity(): 'danger' | 'warn' | 'success' | 'secondary' {
    const status = this.expiryStatus;
    if (status === 'expired') return 'danger';
    if (status === 'expiring-soon') return 'warn';
    if (status === 'valid') return 'success';
    return 'secondary';
  }
}
